export const mealTypes = ["MD", "PRANZ", "CINA"];

export const packageTypes = ["standard", "superior", "gold"];
